import React from 'react';
import { connect } from 'react-redux';
import Application from '../../components/@app/IPO/Application';
import ApplicationStatusEnquiry from '../../components/@app/IPO/ApplicationStatusEnquiry';
import '@/assets/styles/pages/ipo-page.scss';
import ListedFocus from '../../components/@app/IPO/ListedFocus';
import TabHeader from '../../components/TabHeader/TabHeader';
import { CUSTOM_STYLES } from '@/constants/app';

class IPO extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabHeader: [{ id: 1, title: 'ipo_application' }]
    }
  }

  render() {
    const { tabHeader} = this.state;

    return (
      <React.Fragment>
        <div className='ipo-container'>
          <div className="above">
            <TabHeader customStyle={CUSTOM_STYLES.HEADER_NORMAL} tabs={tabHeader} onChange={this.handleChangeTab} refresh onRefresh={this.handleRefresh} />
             <Application innerRef={e => this.applicationRef = e} />
          </div>
          <div className="below">
            <ApplicationStatusEnquiry innerRef={e => this.applicationStatusEnquiryRef = e }/>
          </div>
        </div>
      </React.Fragment>
    )
  }

  handleRefresh = () => {
    if (this.state.selectedTab === 1) {
      this.applicationRef.getData();
    } else {
      this.applicationStatusEnquiryRef.getData();
    }
  }

  handleChangeTab = (tab) => {
    this.setState({ selectedTab: tab.main.id })
  }

  componentDidUpdate(preProps) {

  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
  })
)(IPO)
